
import { Component, Prop, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
import { SapCustomer, SapInvoice } from '@/api/model';
import Helpers from '@/logic/orders/helpers';
import OrderCard from '@/components/orders/OrderCard.vue';
import ShowSalesOrder from '@/components/invoices/ShowSalesOrder.vue';
import DownloadInvoicePdf from '@/components/invoices/DownloadInvoicePdf.vue';
import InvoiceStatus from '@/components/invoices/InvoiceStatus.vue';

@Component({
  components: { DownloadInvoicePdf, OrderCard, InvoiceStatus, ShowSalesOrder },
})
export default class InvoiceDetails extends Vue {
  @Prop(Object)
  invoice!: SapInvoice;

  get fields(): any[] {
    const inv = this.invoice;
    return [
      {
        label: 'type-commercial',
        value: inv.BillTypeText,
        col: 1,
      },
      {
        label: 'invoice-number',
        value: inv.BillDoc,
        col: 1,
      },
      {
        label: 'separator',
        value: '',
        col: 1,
      },
      {
        label: 'sales-order-ship-to',
        value: this.getCustomerValue(inv.ShipToSapCustomer),
        col: 1,
      },
      {
        label: 'relevant-bill-to',
        value: this.getRelevantBillTo(),
        col: 1,
      },
      {
        label: 'relevant-payer',
        value: this.getCustomerValue(inv.PayerSapCustomer),
        col: 1,
      },
      {
        label: 'order-reference',
        value: inv.AssignmentNo,
        col: 1,
      },
      {
        label: 'posting-date',
        value: this.getDate(inv.BillDate),
        col: 2,
      },
      {
        label: 'expire-date',
        value: this.getDate(inv.DueDate),
        col: 2,
      },
      {
        label: 'amount',
        value: inv.NetValue
          ? this.$n(parseFloat(inv.NetValue), {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : '',
        col: 2,
      },
      {
        label: 'currency',
        value: inv.Currency,
        col: 2,
      },
      {
        label: 'payment-terms-code',
        value: inv.Pmnttrms,
        col: 2,
      },
      {
        label: 'payment-terms-description',
        value: inv.PmnttrmsText,
        col: 2,
      },
    ];
  }

  getCustomerValue(customer: SapCustomer | undefined): string {
    return customer ? `${customer.CustName1} - ${customer.City}` : '-';
  }

  getDate(sapDate: string | null | undefined): string | undefined {
    if (sapDate === null || sapDate === undefined) {
      return undefined;
    }
    const date = Helpers.getDateFromSapDate(sapDate);
    if (date instanceof Date && !Number.isNaN(date.getDate())) {
      return format(date, 'dd-MM-yyyy');
    }
    return undefined;
  }

  getRelevantBillTo(): string {
    return this.getCustomerValue(this.$store.state.profile.profile.sapCustomer);
  }
}
